/* eslint-disable */
import { GetCustomerEligiblePromotion, GetCustomerLoyaltyProgram } from '../api/user';
import { CustomerEligiblePromotionsRequest } from './rewardsUtilsInterface';

export const CustomerLoyaltyProgram = async (gcid: any) => {
    try {
        const loyaltyResponse: any = await GetCustomerLoyaltyProgram(gcid)

        const result = {
            loyaltyProgram: loyaltyResponse?.data || null,
            eligiblePromotions: null,
            customerTierCodes: null
        };

        const memberStatus:string = loyaltyResponse?.data?.memberStatus
        const storeNumber: string | null = sessionStorage.getItem('storeNumber');

        if (loyaltyResponse?.status === 200 && memberStatus == 'Active') {
            const payload: CustomerEligiblePromotionsRequest = {
                storeNumber: storeNumber,
                channel: "STORE",
                customer: {
                    globalCustomerId: gcid,
                    tier: loyaltyResponse?.data?.memberTiers?.loyaltyMemberTier
                }
            };
            const promotionResponse = await GetCustomerEligiblePromotion(payload);
            result.eligiblePromotions = promotionResponse?.data?.promotions || null;
            result.customerTierCodes = promotionResponse?.data?.CustomerTierCodes || null;

        }
        console.log(result, "customer loyalty program response");
        return result;
    } catch (error) {
        console.log("Error in REWARD APIS - ", error);
    }
}

export const extractRmsItemNumbers = (addedItem: any) => {
    if (!addedItem || !Array.isArray(addedItem.itemPricing) || addedItem.itemPricing.length === 0) {
        console.log("No items or itemPricing is empty");
        return [];
    }

    const allNumbers = addedItem.itemPricing
        .map(item => item?.rmsItemNumber)
        .filter(Boolean);

    const uniqueNumbers = [...new Set(allNumbers)];

    console.log("Extracted unique rmsItemNumbers:", uniqueNumbers);
    return uniqueNumbers;
};

export const extractInventoryNumber = (addedItem: any) => {
    if (!addedItem || !Array.isArray(addedItem.itemPricing) || addedItem.itemPricing.length === 0) {
        console.log("No items or itemPricing is empty");
        return [];
    }

    const allNumbers = addedItem.itemPricing
        .map(item => item?.inventoryNumber)
        .filter(Boolean);

    const uniqueNumbers = [...new Set(allNumbers)];

    console.log("Extracted unique InventoryNumbers:", uniqueNumbers);
    return uniqueNumbers;
};